<template>
    <div>
      <accounting-books-list></accounting-books-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>